import {
  InternalStorageToolVariant,
  InternalStorageVariantFeatures
} from "./internalStorage.types";

export const INTERNAL_STORAGE_VARIANT_CONFIG: Record<
  InternalStorageToolVariant,
  InternalStorageVariantFeatures
> = {
  mapping: {
    supportsNotes: true,
    supportsDataType: true,
    supportsStorageEnvironment: true,
    supportsWeightUnit: true,
    supportsNewFacility: true,
    supportsFacilityView: true,
    usesSearchFacility: false,
    lockNameWhenSaved: false,
    validateNodeLabel: true,
    deleteTitle: "",
    deleteSubtitle: ""
  },
  simulate: {
    supportsNotes: false,
    supportsDataType: true,
    supportsStorageEnvironment: true,
    supportsWeightUnit: true,
    supportsNewFacility: false,
    supportsFacilityView: true,
    usesSearchFacility: true,
    lockNameWhenSaved: true,
    validateNodeLabel: false,
    deleteTitle: "",
    deleteSubtitle: ""
  },
  supplier: {
    supportsNotes: false,
    supportsDataType: false,
    supportsStorageEnvironment: false,
    supportsWeightUnit: false,
    supportsNewFacility: false,
    supportsFacilityView: true,
    usesSearchFacility: false,
    lockNameWhenSaved: false,
    validateNodeLabel: false,
    deleteTitle: "",
    deleteSubtitle: ""
  }
};

export const getInternalStorageVariantConfig = (
  variant: InternalStorageToolVariant
): InternalStorageVariantFeatures => INTERNAL_STORAGE_VARIANT_CONFIG[variant];
